/*
Copyright 2024 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import DeviceListTable from '../../../components/controllers/devices/device_list/DeviceListTable';
import { DeviceListColumns } from '../../../components/controllers/devices/device_list/DeviceListSchema';
import { createFileRoute } from '@tanstack/react-router';
import { devicesSelectors, useFetchDevicesQuery } from '@/lib/datastore/slices/devices';
import { AuthStates, getAuthState } from '@/lib/auth/auth_state';
import { useTranslation } from '@/i18n/client_hook';
import { defaultNS } from '@/i18n/settings';
import { useFetchProjectsQuery } from '@/lib/datastore/slices/projects';
import { useMemo } from 'react';

export const Route = createFileRoute("/_authenticated/devices/")({
  component: RouteComponent
})

function RouteComponent() {
  const { t } = useTranslation(defaultNS);
  const org_id = getAuthState(AuthStates.activeOrgID)!;

  const { devices } = useFetchDevicesQuery(
    { org_id: org_id }, {
    selectFromResult: ({ data, ...other }) => ({
      ...other,
      devices: data ? devicesSelectors.selectAll(data).filter((device) => (!device.target_fguid)) : []
    })
  });

  const { project_names_map } = useFetchProjectsQuery(
    { org_id: org_id, project_ids: [] }, {
    selectFromResult: ({ data, ...other }) => ({
      ...other,
      project_names_map: useMemo(() =>
        (data ? data.ids.reduce((map_set:Record<string,any>, currProjID:string) => {
          map_set[currProjID] =  data.entities[currProjID].project_name;
          return map_set
        }, {}) : {}) as Record<string, string>
        , [data])
    })
  });

  return <div className="p-6 pt-0">
    {devices && <DeviceListTable
      columns={DeviceListColumns(t, project_names_map)}
      devices={devices} />
    }
  </div>
}